import { ConfigurationValueSelect, IConfigurationValueSelect } from '@/models/configuration/ValuesSelect';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';

export interface IDexieFilterField {
    /**
     * Uuid of the configuration filed
     */
    identifier: string;
    /**
     * Name of the field
     */
    name: string;
    /**
     * Type of the field
     */
    type: FieldTypeEnum;
    /**
     * List of identififers to have path for
     * selected filters list
     */
    identifierPath: string[];
    /**
     * Value of type string.
     * If type is date this is the from date
     */
    valueString?: string;
    /**
     * Value of type string for to values.
     * If type is date this is the to date
     */
    valueStringTo?: string;
    /**
     * List of selectede ax values
     */
    valueAXStrings?: IConfigurationValueSelect[];
    /**
     * List of selected number values.
     * For ranges this is the from value.
     * For select fields this is the list of selected values.
     */
    valueNumber?: number[] | null;
    /**
     * Number value for to value on ranges
     */
    valueNumberTo?: number | null;
    /**
     * For bool fields the value.
     */
    valueBool?: boolean;
}

export class DexieFilterField implements IDexieFilterField {
    public identifier: string;
    public name: string;
    public type: FieldTypeEnum;
    public identifierPath: string[];

    public valueString?: string;
    public valueStringTo?: string;
    public valueAXStrings?: ConfigurationValueSelect[];
    public valueNumber?: number[] | null;
    public valueNumberTo?: number | null;
    public valueBool?: boolean;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieFilterField);
    constructor(obj?: any) {
        this.identifier = (obj && obj.identifier) || '';
        this.name = obj && obj.name ? (obj.name as string).replaceAll('*', '') : '';
        this.type = obj && obj.type != null ? obj.type : FieldTypeEnum.UNKNOWN;
        this.identifierPath = [];

        if (obj) {
            if (obj.identifierPath) {
                obj.identifierPath.forEach((item: string) => {
                    this.identifierPath.push(item);
                });
            }

            if (obj.valueString) {
                this.valueString = obj.valueString;
            }

            if (obj.valueStringTo) {
                this.valueStringTo = obj.valueStringTo;
            }

            if (obj.valueAXStrings) {
                this.valueAXStrings = obj.valueAXStrings;
            }

            if (obj.valueNumber) {
                this.valueNumber = obj.valueNumber;
            }

            if (obj.valueNumberTo) {
                this.valueNumberTo = obj.valueNumberTo;
            }

            if (obj.valueBool) {
                this.valueBool = obj.valueBool;
            }
        }
    }

    public hasNoValuesSet(): boolean {
        return (
            this.valueAXStrings == null &&
            this.valueNumber == null &&
            this.valueNumberTo == null &&
            this.valueString == null &&
            this.valueStringTo == null &&
            (this.valueBool == null || this.valueBool === false)
        );
    }
}
